import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center p-6 text-center">
          <div className="bg-white border border-red-200 rounded-2xl p-6 max-w-md w-full shadow-lg">
            <div className="w-14 h-14 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fa-solid fa-triangle-exclamation text-2xl"></i>
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              पेज लोड करने में समस्या आई
            </h2>
            <p className="text-sm text-gray-600 mb-5 leading-relaxed">
              ब्राउज़र या नेटवर्क में रुकावट के कारण पेज लोड नहीं हो सका। कृपया पेज रिफ्रेश करें।
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleReload}
                className="bg-red-600 text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-red-700 active:scale-95 transition shadow"
              >
                रिफ्रेश करें (Reload)
              </button>
              <a
                href="/"
                className="bg-gray-100 text-gray-800 px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-200 active:scale-95 transition"
              >
                होमपेज पर जाएँ
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
